import React, { useEffect, useState, useContext } from "react";
import "./VoyahFeatures.css";

import feature1 from "../../../../assets/images/voyahfree/exterior/ex1.webp";
import feature2 from "../../../../assets/images/voyahfree/exterior/ex2.webp";
import feature3 from "../../../../assets/images/voyahfree/exterior/ex3.webp";
import feature4 from "../../../../assets/images/voyahfree/exterior/ex4.webp";
import feature5 from "../../../../assets/images/voyahfree/interior/int1.webp";
import feature6 from "../../../../assets/images/voyahfree/interior/int2.webp";
import feature7 from "../../../../assets/images/voyahfree/interior/int3.webp";
import feature8 from "../../../../assets/images/voyahfree/interior/int4.webp";
import feature9 from "../../../../assets/images/voyahfree/interior/int5.webp";
import feature10 from "../../../../assets/images/voyahfree/interior/int6.webp";
import feature11 from "../../../../assets/images/voyahfree/interior/int2.webp";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const HARDCODED_MEDIA = [
  feature1,
  feature2,
  feature3,
  feature4,
  feature5,
  feature6,
  feature7,
  feature8,
  feature9,
  feature10,
  feature11,
];

const buildFeatureItems = (data) => {
  if (!data) return [];

  const items = [];
  for (let n = 1; n <= 20; n += 1) {
    const title = data[`feature_${n}_title`];
    if (!title) break;

    items.push({
      title,
      media: HARDCODED_MEDIA[(n - 1) % HARDCODED_MEDIA.length],
    });
  }

  return items;
};

const VoyahFeatures = () => {
  const { currentLang } = useContext(LanguageContext);

  const [features, setFeatures] = useState(null);
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFeatures = async () => {
      try {
        setLoading(true);

        const response = await getPageContent("voyahfree", currentLang);
        const data = response.sections?.features;
        const items = buildFeatureItems(data);

        setFeatures({
          title: data?.features_title || "Features",
          items,
        });
      } catch (err) {
        console.error("Failed to load Voyah Free features", err);
      } finally {
        setLoading(false);
      }
    };

    loadFeatures();
  }, [currentLang]);

  if (loading || !features || features.items.length === 0) return null;

  const current = features.items[active];

  return (
    <section className="voyah-features">
      <h2 className="voyah-features-title">{features.title}</h2>
      <span className="voyah-features-line" />

      <div className="voyah-features-tabs">
        {features.items.map((item, index) => (
          <div
            key={index}
            className={`voyah-feature-tab ${
              active === index ? "active" : ""
            }`}
            onClick={() => setActive(index)}
          >
            <p>{item.title}</p>
          </div>
        ))}
      </div>

      <div className="voyah-features-media">
        <img key={active} src={current.media} alt={current.title} />
      </div>
    </section>
  );
};

export default VoyahFeatures;
